export const campaignListingTab = {
  CURRENT: 'current',
  PAST: 'past',
};
